/* eslint-disable no-empty */
/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-console,no-nested-ternary,no-useless-escape,max-len */
import router from '@/router';
import apiGateway from '@/services/jApiGateway';
import jwtDecode from 'jwt-decode';

const state = {
  // Set default state(s) here
  idToken: null,
  refreshToken: null,
  profile_data: null,
  is_refresh_token: false,
  login_failed: false,
  data_expire: null,
  roles: [],
  packages: [],
  features: [],
  module: null,
  isHide: false,
};

const getters = {
  // Change value of state(s) with getter

};

const mutations = {
  setDataSidebar(state, data) {
    state.module = data;
  },

  setHideSidebar(state) {
    state.isHide = !state.isHide;
  },

  saveToken(state, data) {
    function parseJwt(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    }
    state.data_expire = parseJwt(data.token);
    state.idToken = data.token;
  },

  setInLocalStorage(state) {
    localStorage.setItem('refreshToken', state.refreshToken);
    const tokenData = {
      value: state.idToken,
      expire: state.data_expire.exp * 1000,
    };
    localStorage.setItem('Token', JSON.stringify(tokenData));
  },

  doLogin() {
    router.push('/home');
  },

  doLoginSiswa() {
    router.push('/home-siswa');
  },

  setProfile(state, payload) {
    state.profile_data = payload.data;
    localStorage.setItem('email', state.profile_data.email);
    localStorage.setItem('full_name', state.profile_data.full_name);
    localStorage.setItem('username', state.profile_data.username);
    localStorage.setItem('photo', state.profile_data.photo.includes('http://sim2.smkn1majalengka.sch.id') ? state.profile_data.photo : '');
    localStorage.setItem('nip', state.profile_data.nip);
    localStorage.setItem('pegawai_id', state.profile_data.pegawai_id);
    localStorage.setItem('roles', JSON.stringify(state.profile_data.roles));
    localStorage.setItem('sidebar', 'home');
  },

  setProfileSiswa(state, payload) {
    state.profile_data = payload.data;
    localStorage.setItem('email', state.profile_data.email);
    localStorage.setItem('nama_siswa', state.profile_data.nama_siswa);
    localStorage.setItem('photo', state.profile_data.photo.includes('http://sim2.smkn1majalengka.sch.id') ? state.profile_data.photo : '');
    localStorage.setItem('nis', state.profile_data.nis);
    localStorage.setItem('id', state.profile_data.id);
    localStorage.setItem('bagikelas', JSON.stringify(state.profile_data.bagikelas));
    localStorage.setItem('sidebar', 'home');
  },
};

const actions = {
  async loginAccount({ commit, dispatch }, authData) {
    dispatch('jStoreNotificationScreen/toggleLoading', 'Please wait...', { root: true });
    let auth;
    try {
      auth = await apiGateway.login(authData);
      commit('saveToken', auth.data);
      commit('setInLocalStorage');
      const getProfil = jwtDecode(auth.data.token);
      commit('setProfile', getProfil);
      commit('doLogin');
      dispatch('jStoreNotificationScreen/toggleLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', auth.message, { root: true });
    }
  },

  async loginAccountSiswa({ commit, dispatch }, authData) {
    dispatch('jStoreNotificationScreen/toggleLoading', 'Please wait...', { root: true });
    let auth;
    try {
      auth = await apiGateway.loginSiswa(authData);
      commit('saveToken', auth.data);
      commit('setInLocalStorage');
      const getProfil = jwtDecode(auth.data.token);
      commit('setProfileSiswa', getProfil);
      commit('doLoginSiswa');
      dispatch('jStoreNotificationScreen/toggleLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', auth.message, { root: true });
    }
  },

  hideSidebar({ commit }) {
    commit('setHideSidebar');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreLogin.js